import React from 'react'
import { Accordion, Button, Modal } from 'react-bootstrap'
import { Icon } from 'react-icons-kit'
import { pencil, bin } from 'react-icons-kit/icomoon/'
import "react-datepicker/dist/react-datepicker.css"
import API from '../Components/Global_API'
import Router from '../Router';
import '../../Css/Dashboard.css'
import NoInternet from '../Components/NoInternet'

const styles = {
    inputDiv: {
        paddingBottom: 10
    },
    tableHeader: {
        fontWeight: '700'
    },
    button: {
        fontWeight: '600'
    },
    icon: {
        display: 'flex',
        flexDirection: 'row-reverse',
        cursor: 'pointer'
    },
    deleteIcon: {
        display: 'flex',
        flexDirection: 'row-reverse',
        color: 'red',
        cursor: 'pointer',
        width: 16
    },
    disableDeleteIcon: {
        display: 'flex',
        flexDirection: 'row-reverse',
        color: '#ff6868',
        cursor: 'no-drop',
        width: 16
    },
    inputAssessor_name: {
        border: 'solid',
        borderWidth: 1,
        borderColor: '#999',
        borderTopWidth: 0,
        listStyle: 'none',
        marginTop: 0,
        maxHeight: 150,
        overflowY: 'auto',
        paddingLeft: 0,
        backgroundColor: "#fff"
    },
    inputAssessor_nameList: {
        padding: 10,
        borderBottom: '1px solid rgba(153, 153, 153, 0.32)',
        cursor: 'pointer'
    },
    activeinputAssessor_name: {
        padding: 10,
        borderBottom: '1px solid rgba(153, 153, 153, 0.32)',
        cursor: 'pointer'
    },
}

const regex = /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g

export default class Course_type extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            new_course_type: '',
            course_data: [],
            delete_course_confirmationpopup: false,
            addnewcpdpopup: false,
            cpd: '',
            showCPDList: false,
            cpd_data: [],
            updatecpdpopup: false,
            delete_level_confirmationpopup: false,
            course_type: '',
            payment_plan: '',
            course_type_list: [],
            payment_plan_data: [],
            new_course_type_popup: false,
            editcpdpopup: false,
            changeCourseStatus: '',
            changeItem: '',
            PublishedCoursePopup: false,
            edit_course_type: '',
            course_type_id: '',
            edit_payment_plan: '',
            isLoader: true,
            new_cpd: '',
            course_name_data: [],
            course_name: '',
            filter_cpd_data: [],
            cpd_id: '',
            edit_cpd: '',
            edit_cpd_id: '',
            deleteCPD: '',
            not_found_msg: '',
            data_updateLoader: false,
            data_deleteLoader: false,
            errorMsg: '',
            errorPopup: false,
            createQualification_type: '',
            editQualification_type:''
        }


        let loginUser = localStorage.getItem("loginUser")
        if (loginUser == null) {
            window.location.href = '/';
        }
    }

    get_course_type = () => {
        fetch(API + 'get_course_type.php')
            .then(res => res.json())
            .then((data) => {

                if (data.result === 'success') {

                    this.setState({ course_type_list: data.course_type_data })
                } else {
                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                    x.innerHTML = data.msg;

                }

            }).catch((error) => {
                console.log(error.message);
            });
    }

    componentDidMount() {
        this.setState({ isLoader: false })

        this.get_course_type();
        fetch(API + 'get_plans.php')
            .then(res => res.json())
            .then((data) => {

                if (data.result === 'success') {

                    this.setState({ payment_plan_data: data.plan_data })
                } else {
                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                    x.innerHTML = data.msg;

                }

            }).catch((error) => {
                console.log(error.message);
            });




        fetch(API + 'display_course.php')
            .then(res => res.json())
            .then((course) => {

                if (course.result === 'success') {
                    this.setState({ course_name_data: course.course_data })
                }

            }).catch((error) => {
                console.log(error.message);
            });
    }


    handleNewCourseType = (e) => {
        if (e.target.value == '') {
            document.getElementsByClassName('error_create_course_type')[0].innerHTML = "Package type is required.";
            document.getElementsByClassName('error_create_course_type')[0].style.display = 'block';
            document.getElementById('create_course_type').classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 50) {
            document.getElementsByClassName('error_create_course_type')[0].innerHTML = "Package type must be between 2 to 50 character.";
            document.getElementsByClassName('error_create_course_type')[0].style.display = 'block';
            document.getElementById('create_course_type').classList.add('error');
        } else {
            document.getElementsByClassName('error_create_course_type')[0].innerHTML = "";
            document.getElementsByClassName('error_create_course_type')[0].style.display = 'none';
            document.getElementById('create_course_type').classList.remove('error');
        }
        this.setState({ new_course_type: e.target.value })
    }

    handleEditCourseType = (e) => {
        this.setState({ edit_course_type: e.target.value })
        if (e.target.value == '') {
            document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "Package type is required.";
            document.getElementsByClassName('error_edit_course_type')[0].style.display = 'block';
            document.getElementById('edit_course_type').classList.add('error');
        } else if (e.target.value.trim().length < 2 || e.target.value.trim().length > 50) {
            document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "Package type must be between 2 to 50 character.";
            document.getElementsByClassName('error_edit_course_type')[0].style.display = 'block';
            document.getElementById('edit_course_type').classList.add('error');
        } else {
            document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
            document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
            document.getElementById('edit_course_type').classList.remove('error');
        }
    }

    handlePaymentPlane = (e) => {
        if (e.target.value == '') {
            document.getElementsByClassName('error_payment_plan')[0].innerHTML = "Payment plan is required.";
            document.getElementsByClassName('error_payment_plan')[0].style.display = 'block';
            document.getElementById('payment_plan').classList.add('error');
        } else {
            document.getElementsByClassName('error_payment_plan')[0].innerHTML = "";
            document.getElementsByClassName('error_payment_plan')[0].style.display = 'none';
            document.getElementById('payment_plan').classList.remove('error');
        }
        this.setState({ payment_plan: e.target.value })
    }

    handleEditPaymentPlane = (e) => {
        this.setState({ edit_payment_plan: e.target.value })
    }

    handleUpdateCourseType = () => {
        this.handleQualificationValidation()
        if (this.state.edit_course_type.trim().length < 2 || this.state.edit_course_type.trim().length > 50) {
            document.getElementById('edit_course_type').focus();
        } else {

            let course_type = JSON.stringify({
                course_type: this.state.edit_course_type,
                // plan: this.state.edit_payment_plan,
                flag: 'edit',
                course_type_id: this.state.course_type_id

            })
            this.setState({ data_updateLoader: true }, () =>
                fetch(API + 'create_course_type.php',
                    {
                        method: 'POST',
                        body: course_type
                    }).then((response) => response.json()).then((responseJsonFromServer) => {
                        var x = document.getElementById("snackbar");
                        x.className = "show";
                        setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                        this.setState({ data_updateLoader: false })
                        if (responseJsonFromServer.result === 'success') {
                            x.innerHTML = responseJsonFromServer.msg;
                            this.get_course_type();
                        } else {
                            x.innerHTML = responseJsonFromServer.msg;
                        }

                    }).catch((error) => {
                        if (error.message == 'Failed to fetch') {
                            this.setState({ networkError: true })
                        }
                    }))
        }
    }

    onClickRemoveError = () => {

        document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
        document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
        document.getElementById('edit_course_type').classList.remove('error');
        this.state.course_type_list.map(item => {
            if (this.state.course_type == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })
    }

    handlecourse_type = (e) => {
        this.setState({ course_type: e.target.value }, () => this.get_cpd())
        this.state.course_type_list.map(item => {
            if (e.target.value == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })
    }

    get_cpd = () => {
        let course_type = JSON.stringify({
            course_type_id: this.state.course_type
        })

        fetch(API + 'display_cpd_or_level.php',
            {
                method: 'POST',

                body: course_type
            }).then((response) => response.json()).then((responseJsonFromServer) => {
                if (responseJsonFromServer.result === 'success') {
                    this.setState({ cpd_data: responseJsonFromServer.cpd_data, course_data: responseJsonFromServer.cpd_data, })
                } else {
                    this.setState({
                        cpd_data: [],
                        course_data: [],
                        not_found_msg: responseJsonFromServer.msg
                    })
                }
            }).catch((error) => {
                if (error.message == 'Failed to fetch') {
                    this.setState({ networkError: true })
                }
            });
    }

    handleNewCourseTypePopup = () => {
        this.handleQualificationValidation()
        this.setState({ new_course_type_popup: true })
        document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
        document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
        document.getElementById('edit_course_type').classList.remove('error');
        this.state.course_type_list.map(item => {
            if (this.state.course_type == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })
    }

    handleNewCourseTypePopupClose = () => {
        this.setState({ new_course_type_popup: false })
    }

    handleSubmitCourseType = () => {
        let errorCount = 0;
        if (this.state.new_course_type.trim().length < 2 || this.state.new_course_type.trim().length > 50) {
            if (this.state.new_course_type == '') {
                document.getElementsByClassName('error_create_course_type')[0].innerHTML = "Package type is required.";
                document.getElementsByClassName('error_create_course_type')[0].style.display = 'block';
                document.getElementById('create_course_type').classList.add('error');
            }
            errorCount++;
        } if (errorCount == 0) {
            let course_type = JSON.stringify({
                course_type: this.state.new_course_type,
                flag: 'create'
            })

            fetch(API + 'create_course_type.php',
                {
                    method: 'POST',
                    body: course_type
                }).then((response) => response.json()).then((responseJsonFromServer) => {
                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

                    if (responseJsonFromServer.result === 'success') {
                        x.innerHTML = responseJsonFromServer.msg;
                        this.setState({ new_course_type: '' })
                        this.get_course_type();
                    } else {
                        x.innerHTML = responseJsonFromServer.msg;
                    }

                }).catch((error) => {
                    if (error.message == 'Failed to fetch') {
                        this.setState({ networkError: true })
                    }
                });
            this.setState({ new_course_type_popup: false })
        }
    }

    handleDeleteCourseTypeConfirm = () => {
        this.handleQualificationValidation()
        this.setState({ delete_course_confirmationpopup: true })
        document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
        document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
        document.getElementById('edit_course_type').classList.remove('error');
        this.state.course_type_list.map(item => {
            if (this.state.course_type == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })
    }

    handleCourseTypePopupClose = () => {
        this.setState({ delete_course_confirmationpopup: false });
    }

    handleDeleteCourseType = () => {
        this.setState({ delete_course_confirmationpopup: false });
        let cpd = JSON.stringify({
            course_type_id: this.state.course_type_id
        })
        this.setState({ data_deleteLoader: true }, () =>
            fetch(API + 'delete_all_cpd.php', {
                method: 'POST',
                body: cpd
            }).then((response) => response.json()).then((responseJsonFromServer) => {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                this.setState({ data_deleteLoader: false })
                if (responseJsonFromServer.result == "success") {
                    x.innerHTML = responseJsonFromServer.msg;
                    this.get_cpd();
                } else {
                    x.innerHTML = responseJsonFromServer.msg;
                }
            }))
    }

    handleCPD = (e) => {
        this.setState({ cpd: e.target.value })

        let filter_data = this.state.cpd_data.filter((item) => {
            return (item.cpd.toLowerCase()).includes(e.target.value.toLowerCase())
        })
        this.setState({ filter_cpd_data: filter_data })

        if (e.target.value.trim().length > 0) {
            this.setState({ showCPDList: true })
        } else {
            this.setState({ showCPDList: false })
        }
    }

    selectedCPD = (item) => {
        this.setState({ showCPDList: false, cpd: item.cpd, cpd_id: item.cpd_id })
    }

    handleCourse = (e) => {
        this.setState({ course_name: e.target.value })
    }

    handleQualification = () => {
        document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
        document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
        document.getElementById('edit_course_type').classList.remove('error');
        this.state.course_type_list.map(item => {
            if (this.state.course_type == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })


        let qualification = JSON.stringify({
            cpd_id: this.state.cpd_id,
            course_type_id: this.state.course_type_id,
            course_id: this.state.course_name
        })

        fetch(API + 'add_cpd_course.php',
            {
                method: 'POST',
                body: qualification
            }).then((response) => response.json()).then((responseJsonFromServer) => {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                if (responseJsonFromServer.result === 'success') {
                    x.innerHTML = responseJsonFromServer.msg;
                    this.setState({ course_name: '', cpd_id: '', cpd: '' })
                    this.get_cpd();
                } else {
                    x.innerHTML = responseJsonFromServer.msg;
                }
            }).catch((error) => {
                if (error.message == 'Failed to fetch') {
                    this.setState({ networkError: true })
                }
            });

    }

    handleNewCPDPopupOpen = (e) => {
        this.setState({ addnewcpdpopup: true, new_cpd: this.state.cpd, cpd: '' })
    }

    handleNewCPDPopupClose = (e) => {
        this.setState({ addnewcpdpopup: false })
        this.setState({ showCPDList: false })
    }

    handleNewCPD = (e) => {
        this.setState({ addnewcpdpopup: false })
        this.setState({ showCPDList: false })

        // let cpd_type = ''
        // if (this.state.new_cpd.toLowerCase().substring(0, 5) == 'level') {
        //     cpd_type = "level"
        // } else {
        //     cpd_type = "cpd"
        // }

        let create_cpd = JSON.stringify({
            course_type_id: this.state.course_type_id,
            cpd: this.state.new_cpd,
            flag: 'create',
            cpd_id: '',
            qualification_type: this.state.createQualification_type
        })

        fetch(API + 'create_cpd.php',
            {
                method: 'POST',
                body: create_cpd
            }).then((response) => response.json()).then((responseJsonFromServer) => {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                if (responseJsonFromServer.result === 'success') {
                    x.innerHTML = responseJsonFromServer.msg;
                    this.setState({ cpd_id: responseJsonFromServer.cpd_id, cpd: responseJsonFromServer.cpd })


                    this.get_cpd();
                } else {
                    x.innerHTML = responseJsonFromServer.msg;
                }


            }).catch((error) => {
                if (error.message == 'Failed to fetch') {
                    this.setState({ networkError: true })
                }
            });

    }

    handleCreateCPD = (e) => {
        this.setState({ new_cpd: e.target.value })
    }

    handleQualification_type= (e) => {
        this.setState({createQualification_type: e.target.value})
    }

    handleEditCPDName = (e) => {
        this.setState({ edit_cpd: e.target.value })
    }

    handleEditQualification_type = (e) => {
        this.setState({editQualification_type: e.target.value})
    }

    handleUpdateCPD = () => {
        this.setState({ editcpdpopup: false })

        // let cpd_type = ''
        // if (this.state.edit_cpd.toLowerCase().substring(0, 5) == 'level') {
        //     cpd_type = "level"
        // } else {
        //     cpd_type = "cpd"
        // }

        let edit_cpd = JSON.stringify({
            course_type_id: this.state.course_type_id,
            cpd: this.state.edit_cpd,
            flag: 'edit',
            cpd_id: this.state.edit_cpd_id,
            qualification_type: this.state.editQualification_type
        })
        console.log("edit_cpd", edit_cpd);

        fetch(API + 'create_cpd.php',
            {
                method: 'POST',
                body: edit_cpd
            }).then((response) => response.json()).then((responseJsonFromServer) => {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
                if (responseJsonFromServer.result === 'success') {
                    x.innerHTML = responseJsonFromServer.msg;
                    this.get_cpd();
                } else {
                    x.innerHTML = responseJsonFromServer.msg;
                }

            }).catch((error) => {
                if (error.message == 'Failed to fetch') {
                    this.setState({ networkError: true })
                }
            });


    }

    handleEditCPDPopupOpen = (item) => {
        // console.log("item",item);
        this.handleQualificationValidation()
        this.setState({ edit_cpd: item.cpd, editcpdpopup: true, edit_cpd_id: item.cpd_id, editQualification_type: item.qualification_type })
        document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
        document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
        document.getElementById('edit_course_type').classList.remove('error');
        this.state.course_type_list.map(item => {
            if (this.state.course_type == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })
    }

    handleEditCPDPopupClose = () => {
        this.setState({ editcpdpopup: false })
    }

    handleDeleteLevelConfirm = (item) => {
        this.handleQualificationValidation()
        document.getElementsByClassName('error_edit_course_type')[0].innerHTML = "";
        document.getElementsByClassName('error_edit_course_type')[0].style.display = 'none';
        document.getElementById('edit_course_type').classList.remove('error');
        this.state.course_type_list.map(item => {
            if (this.state.course_type == item.course_type_id) {
                this.setState({ edit_course_type: item.course_type, edit_payment_plan: item.plan_id, course_type_id: item.course_type_id })
            }
        })

        this.setState({ delete_level_confirmationpopup: true, deleteCPD: item })
    }

    handleLevelPopupClose = () => {
        this.setState({ delete_level_confirmationpopup: false });
    }

    handleDeleteLevel = () => {
        this.setState({ delete_level_confirmationpopup: false });
        let cpd = JSON.stringify({
            cpd_id: this.state.deleteCPD.cpd_id
        })

        fetch(API + 'delete_cpd.php', {
            method: 'POST',
            body: cpd
        }).then((response) => response.json()).then((responseJsonFromServer) => {
            var x = document.getElementById("snackbar");
            x.className = "show";
            setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

            if (responseJsonFromServer.result == "success") {
                x.innerHTML = responseJsonFromServer.msg;
                this.get_cpd();
            } else {
                x.innerHTML = responseJsonFromServer.msg;
            }
        })
    }

    handleCourseStatusPopupOpen(item, course_data) {
        this.setState({
            PublishedCoursePopup: true,
            changeCourseStatus: item,
            changeItem: course_data
        });
    }

    handlePublishedCoursePopupClose = () => {
        this.setState({ PublishedCoursePopup: false });
    }

    handleCourseStatus() {
        this.setState({ PublishedCoursePopup: false });
        var item = this.state.changeCourseStatus;
        var course = this.state.changeItem;


        if (course.cpd_course_status === 'Published') {
            course.cpd_course_status = "Unpublished"
        } else {
            course.cpd_course_status = "Published"
        }
        let data = JSON.stringify(
            {
                course_id: course.course_id,
                course_type_id: this.state.course_type_id,
                cpd_id: item.cpd_id,
                text: course.cpd_course_status
            });


        fetch(API + 'publish_cpd_course.php',
            {
                method: 'POST',
                body: data
            }).then((response) => response.json()).then((responseJsonFromServer) => {

                if (responseJsonFromServer.result === "success") {
                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

                    x.innerHTML = responseJsonFromServer.msg;
                    this.get_cpd();
                } else {
                    this.setState({ errorMsg: responseJsonFromServer.msg, errorPopup: true })
                    this.get_cpd();
                }

            }).catch((error) => {
                if (error.message == 'Failed to fetch') {
                    this.setState({ networkError: true })
                }
            });
    }

    handleQualificationValidation = () => {
        this.setState({ cpd: '', course_name: '', course_id: '', cpd_id: '' })
        this.setState({ addnewcpdpopup: false })
        this.setState({ showCPDList: false })
    }

    render() {
        if (this.state.networkError) {
            return <NoInternet />
        } else {
            if (this.state.isLoader) {
                return (
                    <div style={{ minHeight: '100vh', backgroundColor: '#EEF2F6' }}>
                        <Router />
                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 80 }}>
                            <img src={require('../../assets/Loader.gif')} style={{ width: 100, height: 100 }} />
                        </div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <Router />
                        <div style={{ backgroundColor: '#EEF2F6', minHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                            <div className="block-v-md" style={{ backgroundColor: '#ffff', paddingLeft: 20, paddingTop: 80, paddingRight: 20, paddingBottom: 20 }}>
                                <div style={{ paddingLeft: '2%', paddingRight: '2%' }}>
                                    <div className="row" style={{ marginTop: -10, marginBottom: -10 }}>
                                        <Accordion style={{ width: '100%' }} defaultActiveKey="0">
                                            <div className="row">
                                                <div className="col-md-4 col-sm-4 dashboard-header"></div>
                                                <div className="col-md-4 col-sm-12 text-center pt-3">
                                                    <Accordion.Toggle as={Button} style={{ backgroundColor: '#ebeced', cursor: 'default', whiteSpace: 'normal', width: '100%' }} variant="default" eventKey="0">
                                                        <span style={{ fontWeight: '700' }}>Add / edit package type</span> or Filter by <span style={{ fontWeight: '700' }}>package type</span>
                                                    </Accordion.Toggle>
                                                </div>
                                                <div className="col-md-4 col-sm-12 text-right pr-4 pl-0 pt-3 ">
                                                    <Button onClick={this.handleNewCourseTypePopup} style={styles.button}>Create new package type</Button>
                                                    <Modal size="sm" style={{ marginTop: '20%' }} show={this.state.new_course_type_popup} onHide={this.handleNewCourseTypePopupClose}>
                                                        <Modal.Header style={{ padding: 10 }} closeButton><h6>Create new package type</h6></Modal.Header>
                                                        <Modal.Body >
                                                            <div>
                                                                <h6>Add new package type*</h6>
                                                                <input type="text" id="create_course_type" placeholder="Package type" minLength={2} maxLength={50} value={this.state.new_course_type} className="form-control" onChange={this.handleNewCourseType} />
                                                                <label className="input-error error_create_course_type text-left"></label>
                                                            </div>
                                                            <Button className="mt-2" variant="primary" onClick={() => this.handleSubmitCourseType()} style={styles.button} block>Save package type</Button>
                                                        </Modal.Body>
                                                    </Modal>
                                                </div>
                                            </div>

                                            <div eventKey="0">
                                                <div className="p-4">
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                                        <div className="col-12 p-0">
                                                            <div className="row">
                                                                <div className="col-lg-6 col-md-6 col-sm-12 pl-lg-0 pt-5 left-content">
                                                                    <div className="row" style={{ display: this.state.course_type == '' ? 'none' : 'block' }}>
                                                                        <div className="col-12">
                                                                            <h6>Edit package type*</h6>
                                                                            <input type="text" id="edit_course_type" placeholder="Package type" minLength={2} maxLength={50} value={this.state.edit_course_type} className="form-control" onChange={this.handleEditCourseType} onClick={this.handleQualificationValidation} />
                                                                            <label className="input-error error_edit_course_type text-left"></label>
                                                                        </div>
                                                                        <div className="col-lg-6 col-sm-12 pt-4">
                                                                            <Button block style={styles.button} disabled={this.state.data_updateLoader} onClick={this.handleUpdateCourseType} block>{this.state.data_updateLoader ? 'Loading...' : 'Update package type'}</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2 col-md-2"></div>
                                                                <div className="col-lg-4 col-md-4 col-sm-12 pr-lg-0">
                                                                    <div className="row">
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 right-content" style={styles.inputDiv}>
                                                                            <h6>Search by package type</h6>
                                                                            <select className="form-control" value={this.state.course_type} onClick={() => this.onClickRemoveError(), () => this.handleQualificationValidation()} onChange={this.handlecourse_type}>
                                                                                <option value="">Select package type</option>
                                                                                {this.state.course_type_list.map(item =>
                                                                                    <option value={item.course_type_id}>{item.course_type}</option>
                                                                                )}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                            <div className="body-container" style={{ paddingTop: 40, display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingRight: '2%', paddingLeft: '2%' }}>
                                <div className="col-12" style={{ display: this.state.course_type == '' ? 'none' : 'block' }}>
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <h6>Add new qualification or CPD course</h6>
                                            <div className="row">
                                                <div className="col-lg-5 col-md-4 col-sm-12 mb-3">
                                                    <input placeholder="Level or CPD" className="form-control" maxLength={50} value={this.state.cpd} onClick={this.onClickRemoveError} onChange={this.handleCPD} />
                                                    <div style={{ display: this.state.showCPDList ? '' : 'none' }}>
                                                        {this.state.filter_cpd_data.length == 0 ? <div className="row" style={{ color: 'rgb(123, 123, 123)', padding: '0.5rem' }}>
                                                            <div className="col-lg-3"></div>
                                                            <div className="col-lg-6">
                                                                <Button block style={styles.button} onClick={this.handleNewCPDPopupOpen}>Add new cpd</Button>
                                                                <Modal size="sm" style={{ marginTop: '20%' }} show={this.state.addnewcpdpopup} onHide={this.handleNewCPDPopupClose}>
                                                                    <Modal.Header style={{ padding: 10 }} closeButton><h6>Create new CPD</h6></Modal.Header>
                                                                    <Modal.Body >
                                                                        <input type="text" className="form-control" placeholder="CPD" maxLength={50} value={this.state.new_cpd} onChange={this.handleCreateCPD} />
                                                                        {/* <input type="text" className="form-control" placeholder="CPD" maxLength={50} value={this.state.qualification_type} onChange={this.handleCreateCPD} /> */}
                                                                        <select className="form-control mt-2" value={this.state.createQualification_type} onChange={this.handleQualification_type}>
                                                                            <option value="">Select type</option>
                                                                            <option value="Level">Level</option>
                                                                            <option value="cpd">CPD</option>
                                                                        </select>
                                                                        <Button className="mt-2" variant="primary" disabled={this.state.new_cpd.trim().length < 2 && this.state.createQualification_type.trim().length < 2} onClick={() => this.handleNewCPD()} style={styles.button} block>Save cpd or level</Button>
                                                                    </Modal.Body>
                                                                </Modal>
                                                            </div>
                                                        </div> : <ul style={styles.inputAssessor_name}>
                                                                {this.state.filter_cpd_data.map((item, index) =>
                                                                    <li
                                                                        style={index == this.state.activeAssessor ? styles.activeinputAssessor_name : styles.inputAssessor_nameList}
                                                                        onClick={() => this.selectedCPD(item)}
                                                                        id={item.cpd_id}
                                                                    >
                                                                        {item.cpd}
                                                                    </li>
                                                                )}
                                                            </ul>}
                                                    </div>
                                                </div>
                                                <div className="col-lg-5 col-md-4 col-sm-12 mb-3">
                                                    <select className="form-control" value={this.state.course_name} onClick={this.onClickRemoveError} onChange={this.handleCourse} >
                                                        <option value="" disabled hidden>Select course</option>
                                                        {this.state.course_name_data.map(item =>
                                                            <option value={item.course_id}>{item.course_name}</option>
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-lg-2 col-md-4 col-sm-12 mb-3">
                                                    <Button onClick={this.handleQualification} disabled={this.state.course_name == '' || this.state.cpd_id == ''} style={styles.button} block>Add course</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{ margin: 15 }}>
                                            {this.state.course_data.length == 0 ? <div>
                                                <h4 className="text-center">{this.state.not_found_msg}</h4>
                                            </div> :
                                                <div>
                                                    <div className="col-12 row pr-0 " style={{ borderBottom: '1px solid #999' }}>
                                                        <div className="level">
                                                            <h6>Level</h6>
                                                        </div>
                                                        <div className="row" style={{ width: '70%' }}>
                                                            <div className="course-name" style={{ display: 'flex', paddingLeft: 0 }}>
                                                                <h6>Name</h6>
                                                            </div>
                                                            <div className="course-name">
                                                                <h6>Name</h6>
                                                            </div>
                                                            <div className="course-name display-course-title">
                                                                <h6>Name</h6>
                                                            </div>
                                                            <div className="course-name display-course-title">
                                                                <h6>Name</h6>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    {this.state.course_data.map((item, index) =>


                                                        <div className="col-12 row mr-0 pr-0 pt-2" style={{ borderBottom: '1px solid #999' }}>
                                                            <div className="level">
                                                                <label style={{ width: 200, paddingRight: 5, overflowWrap: 'anywhere' }}>{item.cpd}</label>
                                                                <Icon icon={pencil} size={15} onClick={() => this.handleEditCPDPopupOpen(item)} style={{ cursor: 'pointer' }} />
                                                            </div>
                                                            <div className="row course-list">
                                                                {this.state.course_data[index].course_data.map((course) =>
                                                                    <div className="course-name" style={{ display: 'flex', paddingLeft: 0 }}>
                                                                        <div className="col-lg-6 p-0">
                                                                            <label style={{ fontSize: 15, width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>{course.course_name}</label>
                                                                        </div>
                                                                        <div onClick={() => this.handleCourseStatusPopupOpen(item, course)} style={{ backgroundColor: course.cpd_course_status == 'Published' ? '#1dd61d' : "#fff", width: 20, height: 20, display: 'inline-block', border: '1px solid rgb(113, 110, 110)', cursor: 'pointer' }}></div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="text-right" style={{ width: '10%', flexDirection: 'row-reverse', display: 'flex' }}>
                                                                <Icon icon={bin} size={16} style={this.state.course_data[index].course_data.length > 0 ? styles.deleteIcon : styles.disableDeleteIcon} onClick={this.state.course_data[index].course_data.length > 0 ? () => this.handleDeleteLevelConfirm(item) : ''} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                            <Modal size="sm" style={{ marginTop: '20%' }} show={this.state.editcpdpopup} onHide={this.handleEditCPDPopupClose}>
                                                <Modal.Header style={{ padding: 10 }} closeButton><h6>Edit cpd or level</h6></Modal.Header>
                                                <Modal.Body >
                                                    <input type="text" className="form-control" maxLength={50} placeholder="CPD" value={this.state.edit_cpd} onChange={this.handleEditCPDName} />
                                                    <select className="form-control mt-2" value={this.state.editQualification_type} onChange={this.handleEditQualification_type}>
                                                        <option value="Level">Level</option>
                                                        <option value="cpd">CPD</option>
                                                    </select>
                                                    <Button className="mt-2" variant="primary" disabled={this.state.edit_cpd.trim().length < 2 && this.state.editQualification_type.trim().length < 2} onClick={() => this.handleUpdateCPD()} style={styles.button} block>Update cpd or level</Button>
                                                </Modal.Body>
                                            </Modal>

                                            <Modal size="sm" show={this.state.delete_level_confirmationpopup} onHide={this.handleLevelPopupClose}>
                                                <Modal.Body>Are you sure you want to delete this cpd or level?</Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={this.handleLevelPopupClose}>No</Button>
                                                    <Button variant="primary" onClick={() => this.handleDeleteLevel()}>Yes</Button>
                                                </Modal.Footer>
                                            </Modal>

                                            <Modal size="sm" show={this.state.PublishedCoursePopup} onHide={this.handlePublishedCoursePopupClose}>
                                                <Modal.Body>Are you sure you want to {this.state.changeItem.cpd_course_status == 'Published' ? 'Unpublished' : 'Published'} this course?</Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={this.handlePublishedCoursePopupClose}>No</Button>
                                                    <Button style={styles.confirmButton} onClick={() => this.handleCourseStatus()}>Yes</Button>
                                                </Modal.Footer>
                                            </Modal>

                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingTop: 50, paddingBottom: 50 }}>
                                        <div className="col-lg-9 col-md-9"></div>
                                        <div className="col-lg-3 col-md-3 col-sm-12 delete_button">
                                            <Button variant="danger" disabled={this.state.course_data.length == 0 || this.state.data_deleteLoader} onClick={this.handleDeleteCourseTypeConfirm} block style={{ cursor: this.state.course_data.length == 0 || this.state.data_deleteLoader ? 'no-drop' : 'pointer' }}>{this.state.data_deleteLoader ? 'Loading...' : 'Delete'}</Button>
                                            <Modal size="sm" show={this.state.delete_course_confirmationpopup} onHide={this.handleCourseTypePopupClose}>
                                                <Modal.Body>Are you sure you want to delete all CPD or levels?</Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={this.handleCourseTypePopupClose}>No</Button>
                                                    <Button variant="primary" onClick={() => this.handleDeleteCourseType()}>Yes</Button>
                                                </Modal.Footer>
                                            </Modal>
                                            <Modal size="sm" show={this.state.errorPopup} onHide={() => this.setState({ errorPopup: false })}>
                                                <Modal.Body>{this.state.errorMsg}</Modal.Body>
                                                <Modal.Footer>
                                                    <Button style={styles.confirmButton} block onClick={() => this.setState({ errorPopup: false })}>Ok</Button>
                                                </Modal.Footer>
                                            </Modal>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div id="snackbar"></div>
                        </div>
                    </div>
                )
            }
        }
    }
}